import { delay } from 'redux-saga';
import { select } from 'redux-saga/effects';

export default function*(action) {
  // Question autosave
  yield delay(1000);

  const surveysState = yield select(state => state.surveys);
  const authState = yield select(state => state.auth);

  if (
    action &&
    action.api &&
    surveysState.activeFlow &&
    !surveysState.activeFlow.flows &&
    surveysState.activeFlow.id
  ) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api(
      'updateQuestion',
      newSurveyStateActiveFlow,
      undefined,
      undefined,
      authState
    );
  }
}
